import { createSlice } from '@reduxjs/toolkit'

const createEmptyUser = (country = 'IN', callingCode = '+91') => ({
  value: '',
  type: 'email',
  isValid: false,
  callingCode,
  country
})

const initialState = {
  inviteUsers: Array(5)
    .fill(null)
    .map(() => createEmptyUser())
}

const inviteUsersSlice = createSlice({
  name: 'inviteUsers',
  initialState,
  reducers: {
    updateInviteUserField: (state, action) => {
      const { index, data } = action.payload
      state.inviteUsers[index] = {
        ...state.inviteUsers[index],
        ...data
      }
    },

    addInviteUser: (state) => {
      state.inviteUsers.push(createEmptyUser())
    },

    resetInviteUsers: () => initialState
  }
})

export const { updateInviteUserField, addInviteUser, resetInviteUsers } =
  inviteUsersSlice.actions

export default inviteUsersSlice.reducer
